(function () {
  if (window.__giftWrapInit) return;
  window.__giftWrapInit = true;
  window.__giftWrapVersion = '2026-06-16-delegated';
  console.log('[gift-wrap] script loaded, version', window.__giftWrapVersion);

  function refresh(activeCheckbox) {
    var candidates = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-notification-button', section: 'cart-notification-button', selector: '.shopify-section' },
      { id: 'cart-notification-product', section: 'cart-notification-product', selector: '.cart-notification-products' },
      { id: 'main-cart-items', selector: '.js-contents', useDatasetId: true },
      { id: 'main-cart-footer', selector: '.js-contents', useDatasetId: true },
      { id: 'shopify-section-free-shipping', section: 'free-shipping', selector: '.cart-free-shipping-section' }
    ];
    var targets = candidates.map(function (t) {
      var el = document.getElementById(t.id);
      if (!el) return null;
      var section = t.useDatasetId ? el.dataset.id : t.section;
      if (!section) return null;
      return { id: t.id, section: section, selector: t.selector };
    }).filter(Boolean);
    console.log('[gift-wrap] refresh targets', targets.map(function (t) { return t.id + '=>' + t.section; }));
    if (!targets.length) { if (activeCheckbox) activeCheckbox.disabled = false; return; }
    var names = targets.map(function (t) { return t.section; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(',');
    fetch('/cart?sections=' + names)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        console.log('[gift-wrap] sections returned', Object.keys(data));
        targets.forEach(function (t) {
          var html = data[t.section];
          if (!html) { console.warn('[gift-wrap] no html for section', t.section); return; }
          var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
          var el = document.getElementById(t.id);
          var dest = el.querySelector(t.selector) || el;
          if (incoming) { dest.innerHTML = incoming.innerHTML; console.log('[gift-wrap] updated', t.id); }
          else { console.warn('[gift-wrap] selector not found:', t.selector, 'in', t.section); }
        });
      })
      .catch(function (e) { console.error('[gift-wrap] refresh failed, reloading', e); window.location.reload(); })
      .finally(function () {
        document.querySelectorAll('.cart-gift-wrap__checkbox').forEach(function (c) { c.disabled = false; });
      });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('cart-gift-wrap__checkbox')) return;
    var host = cb.closest('gift-wrap');
    var variantId = host ? host.getAttribute('data-variant-id') : null;
    console.log('[gift-wrap] change fired. checked=', cb.checked, 'variantId=', variantId);
    if (!variantId) { console.warn('[gift-wrap] missing variantId on gift-wrap element'); return; }
    cb.disabled = true;
    var adding = cb.checked;
    var url = adding ? '/cart/add.js' : '/cart/change.js';
    var body = adding
      ? JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      : JSON.stringify({ id: String(variantId), quantity: 0 });
    console.log('[gift-wrap] POST', url, body);
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { console.log('[gift-wrap] response status', r.status); return r.json(); })
      .then(function (d) { console.log('[gift-wrap] response body', d); refresh(cb); })
      .catch(function (err) { console.error('[gift-wrap] request failed', err); cb.disabled = false; });
  });
})();
